import {PATHS} from "../../../../routing/paths";
import {CONTACT, OPERATOR, SERVICE, type LegalDoc} from "./common";

/** Согласие на получение новостной и рекламной рассылки (/consent-mailing). */
export const CONSENT_MAILING_DOC: LegalDoc = {
    title: "Согласие на получение рекламной и новостной рассылки",
    linkLabel: "согласие на получение рассылки",
    path: PATHS.consentMailing,
    updated: "25 августа 2026 г.",
    sections: [
        {
            title: "1. Общие положения",
            body: [
                `Настоящим Пользователь даёт ${OPERATOR} согласие на получение новостной, информационной и рекламной рассылки в сервисе ${SERVICE}.`,
                "Согласие распространяется на получение сообщений по электронной почте, в мобильном приложении, браузерных push-уведомлений и иных каналов связи, указанных при регистрации.",
            ],
        },
        {
            title: "2. Содержание рассылки",
            body: [
                "Новости и обновления Сервиса.",
                "Информация о платных функциях, акциях, скидках и специальных предложениях.",
                "Персонализированные рекомендации и напоминания, связанные с использованием Сервиса.",
            ],
        },
        {
            title: "3. Отзыв согласия",
            body: [
                "Пользователь вправе в любой момент отказаться от получения рассылки, отключив соответствующий пункт в настройках профиля или перейдя по ссылке «Отписаться» в полученном сообщении.",
                `Также отзыв согласия можно направить на ${CONTACT} или через раздел «Поддержка».`,
                "Отказ от рекламной рассылки не влечёт за собой отказ от служебных уведомлений, необходимых для работы Сервиса.",
            ],
        },
        {
            title: "4. Срок действия согласия",
            body: [
                "Согласие действует с момента его подтверждения при регистрации и до момента отзыва.",
                "Персональные данные, используемые для рассылки, обрабатываются в соответствии с Политикой обработки персональных данных.",
            ],
        },
    ],
};
